import React, { FC, useState } from "react"
import styled from "styled-components"
import IconButton, { ICON_BUTTON_SIZES } from "../../../../../IconButton/IconButton"
import { ICON_TYPES } from "@components/Icon/Icon.constants"
import { MEDIA_QUERIES } from "@constants"

const LearnMoreToggleDIV = styled.div`
  align-items: center;
  display: flex;
  min-height: 28px;
  position: absolute;
  right: 0;
  top: 0;

  ${MEDIA_QUERIES.L} {
    left: 0;
    position: relative;
    right: auto;
    top: 0;
  }

  .LearnMoreToggle--button {
    display: flex;
    align-items: center;

    .IconButton {
      background: transparent;
      transition: transform 0.25s;
      width: var(--spacing--base-1-5);
      height: var(--spacing--base-1-5);

      ${MEDIA_QUERIES.M} {
        background: var(--color--orange-200);
        border: 1px solid var(--color--orange-300);
      }

      .Icon {
        background: var(--color--text-headline);
      }
    }

    .type--text-S {
      text-decoration: 1px underline rgba(var(--color--text-default-rgb), 0.5);
      text-underline-offset: 0.2em;
      margin: 0;
    }

    ${MEDIA_QUERIES.M} {
      gap: 6px;
    }
  }

  .LearnMoreToggle--content {
    border-radius: var(--border-radius--L);
    box-shadow: var(--elevation--S);
    right: 0;
    opacity: 0;
    padding: 12px;
    pointer-events: none;
    position: absolute;
    top: calc(100% + 4px);
    transition: opacity 0.3s, translate 0.3s;
    translate: 0 -4px;
    width: 325px;
    z-index: calc(var(--SiteNav--z-index) - 1);

    ${MEDIA_QUERIES.L} {
      box-shadow: none;
      left: 0;
      right: auto;
      top: calc(100% + var(--spacing--XS));
      width: calc(100% + var(--spacing--base-1-5));
    }
  }

  &.is-open {
    .IconButton {
      transform: rotate(180deg);
    }

    .LearnMoreToggle--content {
      background: var(--color--orange-200);
      border: 1px solid var(--color--orange-300);
      opacity: 1;
      pointer-events: all;
      translate: 0;
    }
  }
`

const LearnMoreToggle: FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  return (
    <LearnMoreToggleDIV className={`LearnMoreToggle${isOpen ? " is-open" : ""}`}>
      <button
        className="LearnMoreToggle--button"
        onClick={() => setIsOpen(_isOpen => !_isOpen)}
      >
        <IconButton
          iconType={ICON_TYPES["chevron-down"]}
          size={ICON_BUTTON_SIZES.S}
        />
        <span className="type--text-S">
          Learn about contacts
        </span>
      </button>
      <div className={`LearnMoreToggle--content`}>
        <p className="type--text-S">
          A contact is someone who received a reply from your team or had their question resolved by
          the AI assistant in a given month. Multiple conversations with the same person count as one&nbsp;contact.
        </p>
        <p className="type--text-S margin-bottom--0">
          Help Scout has no per-seat or AI usage fees. We earn revenue when you help&nbsp;customers.
        </p>
      </div>
    </LearnMoreToggleDIV >
  )
}

export default LearnMoreToggle
